export default function Hero() {
  return (
    <section id="hero" className="relative w-full overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 md:pt-28 pb-12 md:pb-16">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium mb-5">
              <i className="ri-sparkling-2-line text-sm"></i>
              <span>2026 暑期档 · 每日更新</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              被窝影院
              <span className="block text-primary-600">你的私人免费影院</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 font-medium mb-4 leading-relaxed">
              随时随地，想看就看
            </p>

            <div className="space-y-3 mb-6">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0">
                被窝影院是面向全国影迷的免费在线观影平台，收录超过十万部最新电影与经典佳作。无论您喜欢好莱坞大片还是国产文艺片，被窝影院电影大全免费看，让您足不出户即可畅享院线电影免费经典电影全集。平台采用智能播放引擎，实现不缓冲流畅在线观看，搭配电影大全无广告的纯净体验，是您发现好电影、重温经典的首选平台。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0">
                本期暑期档专题为您精选百部高分电影在线合集，涵盖动作、科幻、动画、悬疑等热门类型，每日更新最新电影免费看资源，陪你度过最燃夏天。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">日更 50+ 部影片</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">片库超 10 万部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">全网零广告承诺</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-800 font-medium text-sm md:text-base rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center border border-background-300/60"
              >
                查看热播排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20movie%20collage%20with%20film%20reel%20projector%20popcorn%20and%20warm%20theater%20lighting%2C%20golden%20and%20red%20tones%2C%20cozy%20home%20cinema%20atmosphere%2C%20professional%20film%20photography%2C%20artistic%20composition%2C%20warm%20inviting%20mood&width=1200&height=900&seq=hero-main-visual&orientation=landscape"
                alt="被窝影院 - 电影大全免费看，温暖观影体验"
                className="w-full h-full object-cover"
                title="被窝影院 - 电影大全免费看"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}